import { createAction } from "@reduxjs/toolkit";
import { getLivestreamMessagesActionTypes } from "./actionTypes";

// getLivestreamMessagesActionTypes
export const getLivestreamMessages = createAction(
  getLivestreamMessagesActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const getLivestreamMessagesSuccess = createAction(
  getLivestreamMessagesActionTypes.success,
  (payload) => ({ payload }),
);

export const getLivestreamMessagesFailure = createAction(
  getLivestreamMessagesActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);
